var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGlasses = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.55 30H24a1.5 1.5 0 0 0 0-3h-3.974a2.25 2.25 0 0 0-2.115 1.481l-5.814 15.99a1.493 1.493 0 0 0 .08 1.236 1.493 1.493 0 0 0 1.358.793h2.966V48a9 9 0 0 0 9 9h5.25a9 9 0 0 0 9-9v-1.5h4.499V48a9 9 0 0 0 9 9h5.25a9 9 0 0 0 9-9v-1.5h2.965a1.512 1.512 0 0 0 .728-.17 1.495 1.495 0 0 0 .74-.89 1.493 1.493 0 0 0-.03-.969l-5.814-15.99A2.25 2.25 0 0 0 63.975 27H60a1.5 1.5 0 0 0 0 3h3.45l4.908 13.5H67.5a6 6 0 0 0-6-6H50.25a6 6 0 0 0-5.999 6h-4.5a6 6 0 0 0-6-6H22.5a6 6 0 0 0-6 6h-.858L20.55 30Zm13.2 10.5H22.5a3 3 0 0 0-3 3V48a6 6 0 0 0 6 6h5.25a6 6 0 0 0 6-6v-4.5a3 3 0 0 0-3-3Zm16.5 0H61.5a3 3 0 0 1 3 3V48a6 6 0 0 1-6 6h-5.25a6 6 0 0 1-6-6v-4.5a3 3 0 0 1 3-3Z",
    fill: "currentColor"
  }))));
};
export { SvgGlasses as ReactComponent };